module.exports = __webpack_public_path__ + "img/Asset2.03906c6f.png";